import { AiFillLock, AiFillUnlock } from 'react-icons/ai'
import { GoPrimitiveDot } from 'react-icons/go'
const ListItem = ({ status, title, onClick, detail }) => {
  const startTime = new Date(detail.startTime)
  return (
    <div className="listitem">
      <div className="row">
        <div className="col-lg-2">
          <div className="brand">
            <div className="name-box">
              <img src={`${detail.logoList}`} alt="img" className="logo-list d-block mx-auto" />
            </div>
            <span className="action" onClick={onClick}>View pool</span>
          </div>
        </div>
        <div className="col-lg-4">
          <div className="info-wrapper">
            <span className="title">{detail.tokenName}</span>
            <div className="sub-title">1 BNB = 300.000.000 RIM</div>
            <span className="title">Soft/Hard Cap</span>
            <div className="sub-title">{detail.softCap} - {detail.hardCap}</div>
            <div className="progress mt-3 d-block d-lg-none">
              <div className="progress-bar" role="progressbar" style={{ width: '25%' }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
            </div>
            <span className="title">Progress (0%)</span>
          </div>
        </div>
        <div className="col-1 d-none d-lg-flex">
          <div className="barProgress">
            <div className="body">
              <div className="val" style={
                {
                  height: '40%'
                }
              }>
              </div>
              <div className="top">{detail.hardCap}</div>
              <div className="bottom">{detail.softCap}</div>
            </div>
            <div className="perc">0%</div>
          </div>
        </div>
        <div className="col-lg-5">
          <div className="r-info">
            <div className={`badgeStatus ${status === "ONGOING" ? 'live' : 'up-coming'}`}>
              {
                status === "UPCOMING" && <AiFillLock />
              }
              {
                status === "ONGOING" && <AiFillUnlock />
              }
              {
                status === "PAST" && <GoPrimitiveDot />
              }
              {title}
            </div>
            <div className="title">Liquidity% : 70%</div>
            <div className="title">Lockup Time : {detail.liquidityLockupTime} days</div>
            <div className="sale-start">
              <span className="">Sale Start In :</span>
              <div className="timer">
                {`
                ${startTime.getFullYear()} -
                ${startTime.getMonth()+1} -
                ${startTime.getDate()}
                ${startTime.getHours()}:
                ${startTime.getMinutes()}:
                ${startTime.getSeconds()}
                `}
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ListItem
